import React from 'react';
import { Redirect, Link } from "react-router-dom";

import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import InfoIcon from '@material-ui/icons/Info'
import GavelIcon from '@material-ui/icons/Gavel'
import BottomNavigation from 'components/BottomNavigation'
import Loading from 'components/Loading'
import Header from 'components/Header'
import SnackBar from 'components/SnackBar'
import style from 'style/profile.css'
import Matrix from 'scripts/Matrix'
import whatsappLink from '../whatsappLink.js'
import WalletIcon from '@material-ui/icons/AccountBalanceWallet';
import ProfileIcon from '@material-ui/icons/AccountCircle';
import PersonIcon from '@material-ui/icons/Person';
import PhoneIcon from '@material-ui/icons/Phone';
import axios from 'axios'
import Utils from '../Utils.js';


class Profile extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      redirectToLogin: false,
      wallet: {},
      patient: {}
    }
  }

  async componentDidMount() {
    this.fetchWallet()
    this.fetchUserInfo()
  }

  fetchWallet = async () => {
    const result = await axios.get(Utils.urls.myWalletUrl, {
      headers: { 'x-access-token': Matrix.getToken() }
    }).catch(e => {
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    })

    if (!result) return

    const { success, wallet } = result.data

    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')

    this.setState({ wallet })
  }

  fetchUserInfo = async () => {
    const result = await axios.get(Utils.urls.myUserInfoUrl, {
      headers: { 'x-access-token': Matrix.getToken() }
    }).catch(e => {
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    })

    if (!result) return

    const { success, patient } = result.data

    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')

    this.setState({ patient })
  }

  onLogoutClick = async () => {
    await Matrix.logout()
    this.setState({ redirectToLogin: true })
    window.location.reload()
  }

  render() {
    if (this.state.redirectToLogin) {
      return <Redirect to='/login' />
    }
    return (
      <React.Fragment>
        <Header title="طبینجا" showBackButton={false}></Header>
        <div className="profile-root">
          <SnackBar ref={el => { this.SnackBar = el }}></SnackBar>
          <div className='profileImageContainer'>
            <img src={'/images/person.svg'} className='profileImage' />
            <span className='leftSide'>{(this.state.patient.fname || '') + ' ' + (this.state.patient.lname || '')}</span>
          </div>
          <div className='profile-row'>
            <PhoneIcon />
            <span>موبایل</span>
            <span className='leftSide'>{this.state.patient.mobile}</span>
          </div>
          <div className='profile-row'>
            <WalletIcon />
            <span>کیف پول</span>
            <span className="leftSide">{Utils.formatMoney(this.state.wallet.credit)} تومان</span>
          </div>
          <Link to="/aboutUs" className='profile-row'>
            <InfoIcon />
            <span>درباره ما</span>
          </Link>
          <Link to="/terms-condition" className='profile-row'>
            <GavelIcon />
            <span>قوانین و مقررات  </span>
          </Link>
          <a href={whatsappLink} className='profile-row'>
            <HelpOutlineIcon />
            <span>ارتباط با پشتیبانی</span>
          </a>
          <div className='profile-row' onClick={this.onLogoutClick}>
            <MeetingRoomIcon />
            <span>  خروج</span>
          </div>
        </div>
        <BottomNavigation selected='3' />
      </React.Fragment>
    )
  }

}

export default Profile